import { Box, Button, Flex, Popover, PopoverContent, PopoverTrigger } from '@chakra-ui/react'
import { DropdownOptionItem } from '@hb/shared'
import { PropsWithChildren } from 'react'
import { ToggleButton, ToggleContainer } from '../ToolbarComponents'
import { RadioOptionsList } from './RadioOptionsEditor'

// Shared compact toolbar layout for editing a selected radio field: a Row/Column selector, an optional
// slot for extra controls (e.g. the PDF editor's font-size stepper) via `children`, and an "Options"
// button whose popover holds the option-list editing. Used by both the external-PDF (RadioInputToolbar)
// and rich-text (RichTextRadioToolbar) radio toolbars so they share one layout.
export const RadioFieldToolbarControls: React.FC<
  PropsWithChildren<{
    direction: 'row' | 'column'
    onDirectionChange: (direction: 'row' | 'column') => void
    options: DropdownOptionItem[]
    onOptionsChange: (options: DropdownOptionItem[]) => void
  }>
> = ({ direction, onDirectionChange, options, onOptionsChange, children }) => (
  <Flex w="100%" align="center" borderBottom="1px solid" borderColor="gray.300" px={2} gap={2}>
    <ToggleContainer>
      <ToggleButton active={direction === 'row'} onClick={() => onDirectionChange('row')}>
        Row
      </ToggleButton>
      <ToggleButton active={direction === 'column'} onClick={() => onDirectionChange('column')}>
        Column
      </ToggleButton>
    </ToggleContainer>
    {children}
    <Popover placement="bottom-start">
      <PopoverTrigger>
        <Button bg="white" size="xs" variant="outline">
          Options
        </Button>
      </PopoverTrigger>
      <PopoverContent w="280px">
        <Box p={3}>
          <RadioOptionsList options={options} onChange={onOptionsChange} />
        </Box>
      </PopoverContent>
    </Popover>
  </Flex>
)
